import { Action, createReducer, on } from "@ngrx/store";
import { PaginationRequest } from "src/app/models/common/paginationRequest";
import * as DashboardActionTypes from "../../actions/dashboard/dashboard.actions";

export interface DashboardState {
  averages: any[];
  transactions: any[];
  isLoading: boolean;
  isConsumedProductLoading: boolean;
  error: Error;
  pageReq: PaginationRequest;
  totalRecords: number;
}

export const initialState: DashboardState = {
  averages: null,
  transactions: null,
  isLoading: false,
  isConsumedProductLoading: null,
  error: null,
  pageReq: null,
  totalRecords: 0,
};

const dashboardReducer = createReducer(
  initialState,
  on(
    DashboardActionTypes.getVehicleAverageComsuptionList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        options: options,
        isLoading: true,
      } as DashboardState)
  ),
  on(
    DashboardActionTypes.loadVehicleAverageComsuptiontList,
    (state, { response }) => {
      return {
        ...state,
        averages: (response as any)?.result?.items || [],
        error: null,
        isLoading: false,
      };
    }
  ),
  on(
    DashboardActionTypes.getTransactionsList,
    (state, { options }) =>
      ({
        ...state,
        error: null,
        isConsumedProductLoading: true,
        options: options,
      } as DashboardState)
  ),
  on(DashboardActionTypes.loadTransactionsList, (state, { response }) => {
    return {
      ...state,
      transactions: (response as any)?.result?.items || [],
      isConsumedProductLoading: false,
      error: null,
    };
  }),
  on(DashboardActionTypes.setLoadingStartState, (state) => {
    return {
      ...state,
      isLoading: true,
      error: null,
    };
  }),
  on(DashboardActionTypes.setLoadingEndState, (state) => {
    return {
      ...state,
      isLoading: false,
      error: null,
    };
  })
);

export function reducer(state: DashboardState | undefined, action: Action) {
  return dashboardReducer(state, action);
}
